import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

const LinearProgressWithLabel = (props) => {
  const value = Math.min(Math.max(Math.round(props.value || 0), 0), 100);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        width: "100%",
        backgroundColor: "background.paper",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(123, 31, 162, 0.06)",
        px: { xs: 2, sm: 3 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <LinearProgress
          variant="determinate"
          value={value}
          sx={{
            height: 6,
            borderRadius: 3,
            backgroundColor: "rgba(123, 31, 162, 0.08)",
            "& .MuiLinearProgress-bar": {
              borderRadius: 3,
              background: "linear-gradient(90deg, #7B1FA2, #E040FB)",
              transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
            },
          }}
        />
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 600,
          minWidth: 40,
          textAlign: "right",
          fontFeatureSettings: '"tnum"',
          fontSize: "0.8rem",
        }}
      >
        {`${value}%`}
      </Typography>
    </Box>
  );
};

export default LinearProgressWithLabel;
